import { useState } from 'react';
import Icon from '../../../components/AppIcon';

const BeforeAfterGallery = () => {
  const [activeProject, setActiveProject] = useState(0);
  const [showBefore, setShowBefore] = useState(true);

  const projects = [
  {
    id: 1,
    title: "Kitchen Pipe Burst Repair",
    category: "Emergency Repair",
    location: "Johannesburg",
    duration: "2 hours",
    before: "https://img.rocket.new/generatedImages/rocket_gen_img_19e7f412a-1767462375581.png",
    beforeAlt: "Damaged kitchen with water pooling on floor from burst pipe under sink with visible water damage on cabinet doors",
    after: "https://images.unsplash.com/photo-1721274502092-a176b127e648",
    afterAlt: "Pristine modern kitchen with gleaming white cabinets and stainless steel sink showing professional plumbing repair completion",
    description: "Emergency response to burst pipe under kitchen sink. Replaced damaged section, installed new shut-off valves, and restored full functionality.",
    challenges: ["Active water damage", "Limited access space", "Corroded connections"],
    solutions: ["Immediate water shutoff", "Precision pipe replacement", "Upgraded valve system"]
  },
  {
    id: 2,
    title: "Bathroom Leak Detection & Repair",
    category: "Leak Detection",
    location: "Pretoria",
    duration: "4 hours",
    before: "https://img.rocket.new/generatedImages/rocket_gen_img_113ee7df0-1767959579185.png",
    beforeAlt: "Bathroom wall with visible water stains and peeling paint indicating hidden leak behind wall tiles",
    after: "https://images.unsplash.com/photo-1563205249-6d9e228a97a1",
    afterAlt: "Beautifully renovated modern bathroom with pristine white tiles and chrome fixtures showing completed leak repair",
    description: "Used thermal imaging to detect hidden leak behind bathroom wall. Minimal invasive repair preserved tile work while fixing the underlying issue.",
    challenges: ["Hidden leak location", "Tile preservation required", "Multiple potential sources"],
    solutions: ["Thermal imaging scan", "Targeted access point", "Waterproof sealing"]
  },
  {
    id: 3,
    title: "Commercial Kitchen Installation",
    category: "Installation",
    location: "Cape Town",
    duration: "5 days",
    before: "https://img.rocket.new/generatedImages/rocket_gen_img_1e28e896f-1766855235591.png",
    beforeAlt: "Empty commercial kitchen space with exposed concrete floor and rough plumbing connections awaiting installation",
    after: "https://images.unsplash.com/photo-1611601236249-8d9ce49e9a3f",
    afterAlt: "Fully equipped professional commercial kitchen with stainless steel appliances and complete plumbing system installation",
    description: "Complete plumbing installation for new restaurant kitchen. Installed grease traps, multiple sinks, dishwasher connections, and ice machine lines.",
    challenges: ["Health code compliance", "Multiple fixture coordination", "Tight timeline"],
    solutions: ["Detailed planning", "Efficient installation", "Code-compliant systems"]
  },
  {
    id: 4,
    title: "Water Heater Replacement",
    category: "Installation",
    location: "Durban",
    duration: "3 hours",
    before: "https://img.rocket.new/generatedImages/rocket_gen_img_19a1d8bee-1764821639333.png",
    beforeAlt: "Old corroded water heater with rust stains and visible deterioration in basement utility room",
    after: "https://img.rocket.new/generatedImages/rocket_gen_img_10a3712a3-1766470490316.png",
    afterAlt: "New modern energy-efficient water heater professionally installed with clean connections and proper venting in utility room",
    description: "Replaced aging water heater with energy-efficient model. Upgraded venting system and installed new safety valves for optimal performance.",
    challenges: ["Old unit removal", "Venting upgrade needed", "Space constraints"],
    solutions: ["Safe removal process", "Modern venting system", "Compact installation"]
  },
  {
    id: 5,
    title: "Drain System Overhaul",
    category: "Repair",
    location: "Johannesburg",
    duration: "6 hours",
    before: "https://img.rocket.new/generatedImages/rocket_gen_img_13f4f821e-1764900724355.png",
    beforeAlt: "Clogged drain system with standing water and visible debris buildup in residential bathroom",
    after: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9471b19-1766505454674.png",
    afterAlt: "Clean functioning drain system with smooth water flow and professional pipe connections in renovated bathroom",
    description: "Complete drain system cleaning and repair. Removed tree root intrusion, replaced damaged sections, and installed cleanout access points.",
    challenges: ["Root intrusion", "Multiple blockage points", "Aging pipe system"],
    solutions: ["High-pressure jetting", "Strategic pipe replacement", "Preventive access points"]
  },
  {
    id: 6,
    title: "Slab Leak Repair",
    category: "Leak Detection",
    location: "Pretoria",
    duration: "8 hours",
    before: "https://img.rocket.new/generatedImages/rocket_gen_img_147c77a43-1765344649125.png",
    beforeAlt: "Concrete floor with visible moisture damage and cracking indicating slab leak underneath foundation",
    after: "https://img.rocket.new/generatedImages/rocket_gen_img_11e496dc5-1767752274563.png",
    afterAlt: "Repaired concrete floor with smooth finish showing completed slab leak repair with minimal disruption",
    description: "Detected and repaired leak in concrete slab foundation. Used trenchless technology to minimize floor damage and restore structural integrity.",
    challenges: ["Foundation access", "Leak location precision", "Minimal disruption goal"],
    solutions: ["Acoustic leak detection", "Trenchless repair method", "Foundation protection"]
  }];


  const currentProject = projects?.[activeProject];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
            <Icon name="Image" size={20} color="var(--color-primary)" />
            <span className="text-sm font-semibold text-primary">Project Gallery</span>
          </div>
          <h2 className="font-headline text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            See Our Work in Action
          </h2>
          <p className="font-body text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
            Real projects showcasing our expertise, attention to detail, and commitment to quality workmanship.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="bg-card rounded-2xl overflow-hidden border border-border shadow-lg">
              <div className="relative aspect-[16/10] bg-muted">
                <img
                  src={showBefore ? currentProject?.before : currentProject?.after}
                  alt={showBefore ? currentProject?.beforeAlt : currentProject?.afterAlt}
                  className="w-full h-full object-cover" />

                
                <div className="absolute top-4 left-4 bg-card/90 backdrop-blur-sm px-4 py-2 rounded-lg">
                  <span className="text-sm font-semibold text-foreground">
                    {showBefore ? 'Before' : 'After'}
                  </span>
                </div>

                <div className="absolute bottom-4 left-1/2 -translate-x-1/2">
                  <button
                    onClick={() => setShowBefore(!showBefore)}
                    className="flex items-center gap-2 bg-primary hover:bg-primary/90 text-primary-foreground px-6 py-3 rounded-full font-semibold shadow-lg transition-all duration-300">

                    <Icon name={showBefore ? "ArrowRight" : "ArrowLeft"} size={20} />
                    <span>Show {showBefore ? 'After' : 'Before'}</span>
                  </button>
                </div>
              </div>

              <div className="p-6 md:p-8">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="font-headline text-2xl md:text-3xl font-bold text-foreground mb-2">
                      {currentProject?.title}
                    </h3>
                    <div className="flex flex-wrap gap-3">
                      <span className="inline-flex items-center gap-1 text-sm text-muted-foreground">
                        <Icon name="Tag" size={14} />
                        {currentProject?.category}
                      </span>
                      <span className="inline-flex items-center gap-1 text-sm text-muted-foreground">
                        <Icon name="MapPin" size={14} />
                        {currentProject?.location}
                      </span>
                      <span className="inline-flex items-center gap-1 text-sm text-muted-foreground">
                        <Icon name="Clock" size={14} />
                        {currentProject?.duration}
                      </span>
                    </div>
                  </div>
                </div>

                <p className="font-body text-muted-foreground mb-6">
                  {currentProject?.description}
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h4 className="font-headline text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
                      <Icon name="AlertTriangle" size={18} color="var(--color-warning)" />
                      Challenges
                    </h4>
                    <ul className="space-y-2">
                      {currentProject?.challenges?.map((challenge, index) =>
                      <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                          <Icon name="Circle" size={8} className="mt-1.5 flex-shrink-0" />
                          <span>{challenge}</span>
                        </li>
                      )}
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-headline text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
                      <Icon name="CheckCircle" size={18} color="var(--color-success)" />
                      Solutions
                    </h4>
                    <ul className="space-y-2">
                      {currentProject?.solutions?.map((solution, index) =>
                      <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                          <Icon name="Check" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                          <span>{solution}</span>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="font-headline text-xl font-semibold text-foreground mb-4">
              More Projects
            </h3>
            <div className="space-y-3">
              {projects?.map((project, index) =>
              <button
                key={project?.id}
                onClick={() => setActiveProject(index)}
                className={`w-full text-left rounded-xl overflow-hidden border-2 transition-all duration-300 ${
                activeProject === index ?
                'border-primary shadow-md' :
                'border-border hover:border-primary/50'}`
                }>

                  <div className="flex gap-3 p-3">
                    <div className="w-20 h-20 rounded-lg overflow-hidden flex-shrink-0">
                      <img
                      src={project?.after}
                      alt={project?.afterAlt}
                      className="w-full h-full object-cover" />

                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="font-semibold text-foreground mb-1 line-clamp-1">
                        {project?.title}
                      </h4>
                      <p className="text-xs text-muted-foreground mb-1">{project?.category}</p>
                      <div className="flex items-center gap-2 text-xs text-muted-foreground">
                        <Icon name="MapPin" size={12} />
                        <span>{project?.location}</span>
                      </div>
                    </div>
                  </div>
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 bg-gradient-to-br from-primary to-secondary rounded-2xl p-8 md:p-12 text-center text-primary-foreground">
          <h3 className="font-headline text-2xl md:text-3xl font-bold mb-4">
            Ready to Transform Your Plumbing?
          </h3>
          <p className="font-body text-lg opacity-90 mb-6 max-w-2xl mx-auto">
            Let us bring the same level of expertise and quality to your project. Contact us today for a free consultation.
          </p>
          <a
            href="tel:0827935785"
            className="inline-flex items-center justify-center gap-2 bg-accent hover:bg-accent/90 text-accent-foreground px-8 py-4 rounded-lg font-semibold transition-colors emergency-cta">

            <Icon name="Phone" size={20} />
            <span>Call: 082 793 5785</span>
          </a>
        </div>
      </div>
    </section>);

};

export default BeforeAfterGallery;